export default class TouchHandler {
  private initialDistance: number | null = null

  constructor(
    private element: HTMLElement,
    private onStart: (centre: { vx: number; vy: number }) => void,
    private onPinch: (scale: number) => void
  ) {
    this.element.addEventListener("touchstart", this.start.bind(this), false)
    this.element.addEventListener("touchmove", this.move.bind(this), false)
    this.element.addEventListener("touchend", this.end.bind(this), false)
  }

  active(): boolean {
    return this.initialDistance !== null
  }

  private start(event: TouchEvent): void {
    if (event.touches.length === 2) {
      this.initialDistance = this.getDistance(
        event.touches[0],
        event.touches[1]
      )
      const rect = this.element.getBoundingClientRect()
      const initialCentre = {
        vx:
          (event.touches[0].clientX + event.touches[1].clientX) / 2 - rect.left,
        vy:
          (event.touches[0].clientY + event.touches[1].clientY) / 2 - rect.top,
      }
      this.onStart(initialCentre)
    }
  }

  private move(event: TouchEvent): void {
    if (event.touches.length === 2 && this.initialDistance !== null) {
      const currentDistance = this.getDistance(
        event.touches[0],
        event.touches[1]
      )
      const scale = currentDistance / this.initialDistance
      this.onPinch(scale)
    }
  }

  private end(event: TouchEvent): void {
    this.initialDistance = null
  }

  private getDistance(touch1: Touch, touch2: Touch): number {
    const dx = touch1.clientX - touch2.clientX
    const dy = touch1.clientY - touch2.clientY
    return Math.sqrt(dx * dx + dy * dy)
  }
}

// const element = document.querySelector('.zoomable') as HTMLElement;
// new TouchHandler(element);
